import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionService } from 'src/app/shared/services/permission.service';

export const pageAccessGuard: CanActivateFn = (route, state) => {

  const router = inject(Router)

  const permissionService = inject(PermissionService) 
  const permissionList = permissionService.getPermissions().map((p: any) => { 
    return p.page
  })
  const page = route.data['access']
  if(permissionList.includes(page)){

    return true;
  } else {
    router.navigateByUrl('login')
    return false
  }
  
};
